import _ from "lodash";
import { axiosInstance } from "./globals";
import * as userService from "./userService";

import {DataSourceRequest} from "@/model/DataSourceRequest";
import {DataSourceResult} from "@/model/DataSourceResult";
import {IpPolicyFilter} from "@/model/filters";


export async function getAll(filter: IpPolicyFilter): Promise<DataSourceResult<any>> {
  const headers = userService.getAuthHeaders();

  const body: DataSourceRequest = {
    page: filter.page,
    pageSize: filter.pageSize,
    filters: [],
    sorts: [
      { field: "id", dir: "desc" }
    ]
  };

  if (filter.q) {
    body.filters.push(
      { field: "ipAddress", operator: "contains", value: filter.q, logic: "or" },
      { field: "comment", operator: "contains", value: filter.q, logic: "or" }
    );
  }

  return (await axiosInstance.post<DataSourceResult<any>>("/IpPolicy/GetAll", body, { headers })).data;
}

export async function add(body: { ipAddress: string, comment: string }) {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.post("/IpPolicy/Add", body, { headers })).data;
}

export async function del(id: number) {
  const headers = userService.getAuthHeaders();
  const params = { id };
  return (await axiosInstance.post("/IpPolicy/Delete", null, { headers, params })).data;
}

